module.exports = __webpack_public_path__ + "img/yishi7.e6160ab0.jpg";